export const countryCodes = [
  { code: '+1', country: 'US/Canada', iso: 'US' },
  { code: '+44', country: 'UK', iso: 'GB' },
  { code: '+91', country: 'India', iso: 'IN' },
  { code: '+61', country: 'Australia', iso: 'AU' },
  { code: '+86', country: 'China', iso: 'CN' },
  { code: '+81', country: 'Japan', iso: 'JP' },
  { code: '+49', country: 'Germany', iso: 'DE' },
  { code: '+33', country: 'France', iso: 'FR' },
  { code: '+39', country: 'Italy', iso: 'IT' },
  { code: '+34', country: 'Spain', iso: 'ES' },
  { code: '+31', country: 'Netherlands', iso: 'NL' },
  { code: '+46', country: 'Sweden', iso: 'SE' },
  { code: '+47', country: 'Norway', iso: 'NO' },
  { code: '+45', country: 'Denmark', iso: 'DK' },
  { code: '+358', country: 'Finland', iso: 'FI' },
  { code: '+41', country: 'Switzerland', iso: 'CH' },
  { code: '+43', country: 'Austria', iso: 'AT' },
  { code: '+32', country: 'Belgium', iso: 'BE' },
  { code: '+351', country: 'Portugal', iso: 'PT' },
  { code: '+353', country: 'Ireland', iso: 'IE' },
  { code: '+48', country: 'Poland', iso: 'PL' },
  { code: '+420', country: 'Czech Republic', iso: 'CZ' },
  { code: '+36', country: 'Hungary', iso: 'HU' },
  { code: '+421', country: 'Slovakia', iso: 'SK' },
  { code: '+386', country: 'Slovenia', iso: 'SI' },
  { code: '+385', country: 'Croatia', iso: 'HR' },
  { code: '+387', country: 'Bosnia and Herzegovina', iso: 'BA' },
  { code: '+382', country: 'Montenegro', iso: 'ME' },
  { code: '+389', country: 'North Macedonia', iso: 'MK' },
  { code: '+355', country: 'Albania', iso: 'AL' },
  { code: '+30', country: 'Greece', iso: 'GR' },
  { code: '+357', country: 'Cyprus', iso: 'CY' },
  { code: '+356', country: 'Malta', iso: 'MT' },
  { code: '+372', country: 'Estonia', iso: 'EE' },
  { code: '+371', country: 'Latvia', iso: 'LV' },
  { code: '+370', country: 'Lithuania', iso: 'LT' },
  { code: '+7', country: 'Russia/Kazakhstan', iso: 'RU' },
  { code: '+380', country: 'Ukraine', iso: 'UA' },
  { code: '+375', country: 'Belarus', iso: 'BY' },
  { code: '+52', country: 'Mexico', iso: 'MX' },
  { code: '+55', country: 'Brazil', iso: 'BR' },
  { code: '+54', country: 'Argentina', iso: 'AR' },
  { code: '+56', country: 'Chile', iso: 'CL' },
  { code: '+57', country: 'Colombia', iso: 'CO' },
  { code: '+58', country: 'Venezuela', iso: 'VE' },
  { code: '+51', country: 'Peru', iso: 'PE' },
  { code: '+593', country: 'Ecuador', iso: 'EC' },
  { code: '+595', country: 'Paraguay', iso: 'PY' },
  { code: '+598', country: 'Uruguay', iso: 'UY' },
  { code: '+591', country: 'Bolivia', iso: 'BO' },
  { code: '+27', country: 'South Africa', iso: 'ZA' },
  { code: '+234', country: 'Nigeria', iso: 'NG' },
  { code: '+254', country: 'Kenya', iso: 'KE' },
  { code: '+251', country: 'Ethiopia', iso: 'ET' },
  { code: '+20', country: 'Egypt', iso: 'EG' },
  { code: '+212', country: 'Morocco', iso: 'MA' },
  { code: '+216', country: 'Tunisia', iso: 'TN' },
  { code: '+213', country: 'Algeria', iso: 'DZ' },
  { code: '+221', country: 'Senegal', iso: 'SN' },
  { code: '+233', country: 'Ghana', iso: 'GH' },
  { code: '+225', country: 'Ivory Coast', iso: 'CI' },
  { code: '+237', country: 'Cameroon', iso: 'CM' },
  { code: '+235', country: 'Chad', iso: 'TD' },
  { code: '+236', country: 'Central African Republic', iso: 'CF' },
  { code: '+238', country: 'Cape Verde', iso: 'CV' },
  { code: '+239', country: 'São Tomé and Príncipe', iso: 'ST' },
  { code: '+240', country: 'Equatorial Guinea', iso: 'GQ' },
  { code: '+241', country: 'Gabon', iso: 'GA' },
  { code: '+242', country: 'Republic of the Congo', iso: 'CG' },
  { code: '+243', country: 'Democratic Republic of the Congo', iso: 'CD' },
  { code: '+244', country: 'Angola', iso: 'AO' },
  { code: '+245', country: 'Guinea-Bissau', iso: 'GW' },
  { code: '+246', country: 'British Indian Ocean Territory', iso: 'IO' },
  { code: '+247', country: 'Ascension Island', iso: 'SH' },
  { code: '+248', country: 'Seychelles', iso: 'SC' },
  { code: '+249', country: 'Sudan', iso: 'SD' },
  { code: '+250', country: 'Rwanda', iso: 'RW' },
  { code: '+252', country: 'Somalia', iso: 'SO' },
  { code: '+253', country: 'Djibouti', iso: 'DJ' },
  { code: '+255', country: 'Tanzania', iso: 'TZ' },
  { code: '+256', country: 'Uganda', iso: 'UG' },
  { code: '+257', country: 'Burundi', iso: 'BI' },
  { code: '+258', country: 'Mozambique', iso: 'MZ' },
  { code: '+259', country: 'Zanzibar', iso: 'TZ' },
  { code: '+260', country: 'Zambia', iso: 'ZM' },
  { code: '+261', country: 'Madagascar', iso: 'MG' },
  { code: '+262', country: 'Réunion', iso: 'RE' },
  { code: '+263', country: 'Zimbabwe', iso: 'ZW' },
  { code: '+264', country: 'Namibia', iso: 'NA' },
  { code: '+265', country: 'Malawi', iso: 'MW' },
  { code: '+266', country: 'Lesotho', iso: 'LS' },
  { code: '+267', country: 'Botswana', iso: 'BW' },
  { code: '+268', country: 'Eswatini', iso: 'SZ' },
  { code: '+269', country: 'Comoros', iso: 'KM' },
  { code: '+290', country: 'Saint Helena', iso: 'SH' },
  { code: '+291', country: 'Eritrea', iso: 'ER' },
  { code: '+297', country: 'Aruba', iso: 'AW' },
  { code: '+298', country: 'Faroe Islands', iso: 'FO' },
  { code: '+299', country: 'Greenland', iso: 'GL' },
  { code: '+350', country: 'Gibraltar', iso: 'GI' },
  { code: '+352', country: 'Luxembourg', iso: 'LU' },
  { code: '+354', country: 'Iceland', iso: 'IS' },
  { code: '+376', country: 'Andorra', iso: 'AD' },
  { code: '+377', country: 'Monaco', iso: 'MC' },
  { code: '+378', country: 'San Marino', iso: 'SM' },
  { code: '+379', country: 'Vatican City', iso: 'VA' },
  { code: '+381', country: 'Serbia', iso: 'RS' },
  { code: '+383', country: 'Kosovo', iso: 'XK' },
  { code: '+423', country: 'Liechtenstein', iso: 'LI' },
  { code: '+500', country: 'Falkland Islands', iso: 'FK' },
  { code: '+501', country: 'Belize', iso: 'BZ' },
  { code: '+502', country: 'Guatemala', iso: 'GT' },
  { code: '+503', country: 'El Salvador', iso: 'SV' },
  { code: '+504', country: 'Honduras', iso: 'HN' },
  { code: '+505', country: 'Nicaragua', iso: 'NI' },
  { code: '+506', country: 'Costa Rica', iso: 'CR' },
  { code: '+507', country: 'Panama', iso: 'PA' },
  { code: '+508', country: 'Saint Pierre and Miquelon', iso: 'PM' },
  { code: '+509', country: 'Haiti', iso: 'HT' },
  { code: '+590', country: 'Guadeloupe', iso: 'GP' },
  { code: '+592', country: 'Guyana', iso: 'GY' },
  { code: '+594', country: 'French Guiana', iso: 'GF' },
  { code: '+596', country: 'Martinique', iso: 'MQ' },
  { code: '+597', country: 'Suriname', iso: 'SR' },
  { code: '+599', country: 'Netherlands Antilles', iso: 'CW' },
  { code: '+670', country: 'East Timor', iso: 'TL' },
  { code: '+672', country: 'Australian External Territories', iso: 'AU' },
  { code: '+673', country: 'Brunei', iso: 'BN' },
  { code: '+674', country: 'Nauru', iso: 'NR' },
  { code: '+675', country: 'Papua New Guinea', iso: 'PG' },
  { code: '+676', country: 'Tonga', iso: 'TO' },
  { code: '+677', country: 'Solomon Islands', iso: 'SB' },
  { code: '+678', country: 'Vanuatu', iso: 'VU' },
  { code: '+679', country: 'Fiji', iso: 'FJ' },
  { code: '+680', country: 'Palau', iso: 'PW' },
  { code: '+681', country: 'Wallis and Futuna', iso: 'WF' },
  { code: '+682', country: 'Cook Islands', iso: 'CK' },
  { code: '+683', country: 'Niue', iso: 'NU' },
  { code: '+685', country: 'Samoa', iso: 'WS' },
  { code: '+686', country: 'Kiribati', iso: 'KI' },
  { code: '+687', country: 'New Caledonia', iso: 'NC' },
  { code: '+688', country: 'Tuvalu', iso: 'TV' },
  { code: '+689', country: 'French Polynesia', iso: 'PF' },
  { code: '+690', country: 'Tokelau', iso: 'TK' },
  { code: '+691', country: 'Micronesia', iso: 'FM' },
  { code: '+692', country: 'Marshall Islands', iso: 'MH' },
  { code: '+850', country: 'North Korea', iso: 'KP' },
  { code: '+852', country: 'Hong Kong', iso: 'HK' },
  { code: '+853', country: 'Macau', iso: 'MO' },
  { code: '+855', country: 'Cambodia', iso: 'KH' },
  { code: '+856', country: 'Laos', iso: 'LA' },
  { code: '+880', country: 'Bangladesh', iso: 'BD' },
  { code: '+886', country: 'Taiwan', iso: 'TW' },
  { code: '+960', country: 'Maldives', iso: 'MV' },
  { code: '+961', country: 'Lebanon', iso: 'LB' },
  { code: '+962', country: 'Jordan', iso: 'JO' },
  { code: '+963', country: 'Syria', iso: 'SY' },
  { code: '+964', country: 'Iraq', iso: 'IQ' },
  { code: '+965', country: 'Kuwait', iso: 'KW' },
  { code: '+966', country: 'Saudi Arabia', iso: 'SA' },
  { code: '+967', country: 'Yemen', iso: 'YE' },
  { code: '+968', country: 'Oman', iso: 'OM' },
  { code: '+970', country: 'Palestine', iso: 'PS' },
  { code: '+971', country: 'United Arab Emirates', iso: 'AE' },
  { code: '+972', country: 'Israel', iso: 'IL' },
  { code: '+973', country: 'Bahrain', iso: 'BH' },
  { code: '+974', country: 'Qatar', iso: 'QA' },
  { code: '+975', country: 'Bhutan', iso: 'BT' },
  { code: '+976', country: 'Mongolia', iso: 'MN' },
  { code: '+977', country: 'Nepal', iso: 'NP' },
  { code: '+992', country: 'Tajikistan', iso: 'TJ' },
  { code: '+993', country: 'Turkmenistan', iso: 'TM' },
  { code: '+994', country: 'Azerbaijan', iso: 'AZ' },
  { code: '+995', country: 'Georgia', iso: 'GE' },
  { code: '+996', country: 'Kyrgyzstan', iso: 'KG' },
  { code: '+998', country: 'Uzbekistan', iso: 'UZ' }
];

export default countryCodes;
